import React from "react"
import ResourceCard from "components/cards/resources-card"

// markup
const IndexPage = ({ data }) => {
    return data.posts.edges.map((post, index) => {
        const { node } = post
        const resource = {
            summary: node.summary,
            imageFile: node.image,
            title: node.title,
            author: node.author.name,
            tag: node.tags[0].name,
            slug: "/resources/" + node.slug,
        }
        return <ResourceCard key={index} {...resource} />
    })
}

export default IndexPage
